import React from 'react';

import MonthDaysHeader from './MonthDaysHeader';
import MonthRows from './MonthRows';

const MonthSchedule = () => {
  return (
    <>
      <MonthDaysHeader />
      <MonthRows />
    </>
  );
};

export default MonthSchedule;
